import {
  IDataPreference,
  IFiltrosPainelDeVendas
} from "@/features/financas/views/Indicadores/@types/type";
import { AbstractSaveToApi } from "../../Preferencias/types";
import VendasPanelStrategy from "./VendasPanelStrategy";

export default class SaveVendasPanelToApi extends AbstractSaveToApi<IFiltrosPainelDeVendas> {
  buildPreference(filtro: IFiltrosPainelDeVendas): IDataPreference<unknown>[] {
    const preferencia = new VendasPanelStrategy();

    const preferenciasVendas: IDataPreference<unknown>[] = [];

    if (filtro.companies && filtro.companies?.length >= 1) {
      preferenciasVendas.push(
        preferencia.createCompanies(filtro.companies as string[])
      );
    }

    if (filtro.sourceData) {
      preferenciasVendas.push(preferencia.createSourceData(filtro.sourceData));
    }

    return preferenciasVendas;
  }
}
